import React, { useState } from 'react'
import Modal from '@mui/material/Modal';
import deactive from '../../../images/deactive.png'
import CurrencyInput from '../../common/TransForm/CurrencyInput'

import { Box, Button, Grid, Input, Typography } from "@mui/material";
import { PnpSelect } from './PnpSelect';

export default function ModalPopUp({ 
  title, 
  subTitle, 
  popupType = 'default', 
  onChange, 
  save, 
  cancel, 
  openpopup, 
  textArea, 
  saveBtnBg, 
  setPopup, 
  onClick, 
  sx, 
  values,
  customContent,  // Add this prop
  hideDefaultButtons = false  // Add this prop
}) {
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    ...sx
  };

  const getPopupType = () => {
    if (popupType == 'player') {
      return <Box sx={{ justifyContent: "center", display: 'flex' }}> 
        <Input
          sx={{ mt: 5, width: '250px' }}
          type={'number'}
          onChange={onChange}
        />
      </Box>
    } else if (popupType == 'payout') {
      return <Box >
        <CurrencyInput 
          name={'Amount'} 
          countryCode={values.countryCode} 
          value={values.amount} 
          onChange={onChange} 
          selectDisable={true} 
        />
      </Box>
    }
  }

  return (
    <div>
      <Modal
        open={openpopup}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          {textArea && <img src={deactive} alt='deactive' />}

          <Typography id="modal-modal-title" variant="h6" component="h2">
            {title}
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            {subTitle}
          </Typography>

          {/* Handle custom content */}
          {customContent ? (
            customContent
          ) : (
            // Original content logic
            popupType == 'default' ? textArea ?
              <Box sx={{ mx: 'auto', textAlign: 'center', }}>
                <textarea placeholder='Enter the reason to deactivate' style={{
                  width: "500px",
                  height: "100px",
                  resize: 'none',
                  border: '1px solid #000',
                  padding: '2%'
                }}></textarea>
              </Box>
              : ''
              : getPopupType()
          )}

          {/* Only show default buttons if hideDefaultButtons is false and no customContent */}
          {!hideDefaultButtons && !customContent && (
            <Box sx={{ mt: 6 }}>
              <Button onClick={onClick} sx={{
                backgroundColor: saveBtnBg ? saveBtnBg : '#3C50E0', 
                color: '#fff', 
                px: 6, 
                "&:hover": {
                  backgroundColor: saveBtnBg ? saveBtnBg : "#3C50E0",
                  color: "#fff",
                },
              }}>
                {save}
              </Button>
              <Button onClick={() => setPopup(false)} sx={{ 
                backgroundColor: '#fff', 
                color: '#000', 
                border: '#E2E8F0 1px solid', 
                ml: 2 
              }}>
                {cancel}
              </Button>
            </Box>
          )}
        </Box>
      </Modal>
    </div>
  )
}